import { render, staticRenderFns } from "./SubMasterForm.vue?vue&type=template&id=01f1ea65"
import script from "./SubMasterForm.vue?vue&type=script&lang=js"
export * from "./SubMasterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports